import { render, staticRenderFns } from "./EModalCarteirinhaVisualizar.vue?vue&type=template&id=79c5d5d9&scoped=true"
import script from "./EModalCarteirinhaVisualizar.vue?vue&type=script&lang=js"
export * from "./EModalCarteirinhaVisualizar.vue?vue&type=script&lang=js"
import style0 from "./EModalCarteirinhaVisualizar.vue?vue&type=style&index=0&id=79c5d5d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c5d5d9",
  null
  
)

export default component.exports